import React, { useEffect } from "react";
import { connect } from 'react-redux'
import { Row,Col,Table,Button,Card,CardHeader,CardBody } from "reactstrap"
import { Link } from 'react-router-dom'
import _ from "lodash"

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid"
import columns from "./columns"

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized"
import HasRole from "modules/5_view_helpers/HasRole"

// Actions
import { getProjectTwrEsmCategories } from "../actions"



function mapStateToProps(state) {
	return {
		project_twr_esm_categories:state.project_twr_esm_categories,
	}
}

const ProjectTwrEsmCategoriesIndex = (props) => {
	useEffect(() => {
		props.getProjectTwrEsmCategories()
	},[])

	const { project_twr_esm_categories } = props

	const readRole = HasRole({resource_type:"Project::Twr::EsmCategory",name:["read","moderator"]})
	const createRole = HasRole({resource_type:"Project::Twr::EsmCategory",name:["create","moderator"]})
	const updateRole = HasRole({resource_type:"Project::Twr::EsmCategory",name:["update","moderator"]})

	


	if (!readRole) {
		return <NotAuthorized />;
	}
	else{
		return (
			<Card>
				<CardHeader>
					<Row>
						<Col><h3>Esm categories</h3></Col>
					</Row>
				</CardHeader>

				<CardBody>
					
					{createRole && (<Row>
						<Col>
							<Link to="/project/twr/esm_categories/new">
								<Button color="primary" size="md"><i className="fa fa-plus"> Create New Esm category</i></Button>
							</Link>
						</Col>
					</Row>)}


					<Row className="mt-2">
						<Col>
							<DefaultDataGrid 
								columns={columns(updateRole)}
								data={project_twr_esm_categories}
							/>
						</Col>
					</Row>
				</CardBody>
			</Card>
		);
	}
}
export default connect(mapStateToProps,{getProjectTwrEsmCategories})(ProjectTwrEsmCategoriesIndex)

